exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-entrada-detalle-list/documento-entrada-detalle-list.component.css
// module id = ../../../../../src/app/components/documento-entrada-detalle-list/documento-entrada-detalle-list.component.css
// module chunks = main